const ValidationMessages = () => {
    return Object.freeze({
        rating: {
            messages: {
                required: 'Please answer required question (1 to 5).',
            }
        },
        yesNo: {
            messages: {
                required: 'Please answer required question (yes or no).',
            }
        },
        simple: {
            messages: {
                required: 'The field is required.',
            }
        }

    });
}

export default ValidationMessages